export const ALFRED_TOUR_STORAGE_KEY = "alfred-device-tour-seen:v1"
export const ALFRED_TOUR_AUTO_START_KEY = "alfred-device-tour-auto-start:v1"
export const ALFRED_TOUR_ACTION_EVENT = "alfred-device-tour-action"

export type AlfredTourAction =
  | "show-bulk-actions"
  | "preview-bulk-actions"
  | "exit-bulk"
  | "exit-bulk-preview"

export function dispatchAlfredTourAction(action: AlfredTourAction) {
  window.dispatchEvent(
    new CustomEvent<AlfredTourAction>(ALFRED_TOUR_ACTION_EVENT, {
      detail: action,
    }),
  )
}

export function requestAlfredTourAutoStart(pathname: string) {
  try {
    window.sessionStorage.setItem(ALFRED_TOUR_AUTO_START_KEY, pathname)
  } catch {
    // Authentication should continue when browser storage is unavailable.
  }
}

export function consumeAlfredTourAutoStart(pathname: string) {
  try {
    if (window.sessionStorage.getItem(ALFRED_TOUR_AUTO_START_KEY) !== pathname) return false
    window.sessionStorage.removeItem(ALFRED_TOUR_AUTO_START_KEY)
    return true
  } catch {
    return false
  }
}

export function resetAlfredTour() {
  try {
    window.sessionStorage.removeItem(ALFRED_TOUR_STORAGE_KEY)
    window.sessionStorage.removeItem(ALFRED_TOUR_AUTO_START_KEY)
  } catch {
    // Authentication and logout should continue when browser storage is unavailable.
  }
}
